<app-toast [toastModel]="toastViewModel" *ngIf="isShowToast"></app-toast>
<div class="regular_chat card position-relative" [ngClass]="isCollapse ? 'overflow-hidden': ''">
    <aside class="sidebar_chat_card position-relative" [ngClass]="isCollapse ? 'collapseSidebar': ''">
        <div class="header">
            <div class="logo d-flex align-items-center gap-1" (click)="newChat()">
                <div class="round">
                    <img src="../../../assets/images/bot.png" />
                </div>
                <span>New Insight</span>
            </div>
            <lucide-icon size="16" class="text-blue-lucide" name="square-pen"></lucide-icon>
        </div>
        <button class="collapse_button btn" (click)="collapseSidebar()">
            <i class="fa" aria-hidden="true" [ngClass]="isCollapse ? 'fa-angle-right' : 'fa-angle-left'"></i>
        </button>
        <nav class="sidebar_nav pt-1">
            <!-- Today Chats -->
            <div *ngIf="todayChats.length > 0" class="chats_timing pt-2">
                <h3>Today</h3>
                <ul>
                    <li *ngFor="let chat of todayChats" [class.active]="chat.isActive">
                        <span class="d-block w-100" *ngIf="editChatUuid !== chat.uuid"
                            (click)="getUserChatDetails(chat, false)">{{ chat.chatName }}</span>
                        <input *ngIf="editChatUuid === chat.uuid" [(ngModel)]="newChatName" (blur)="saveChatName(chat)"
                            (keydown.enter)="saveChatName(chat)" (keydown.esc)="cancelEdit()"
                            class="chat-edit-input w-100 py-2 px-2" />
                        <div class="overlay" (click)="getUserChatDetails(chat, false)"
                            *ngIf="editChatUuid !== chat.uuid"></div>
                        <button [matMenuTriggerFor]="todayMenu" *ngIf="editChatUuid !== chat.uuid">
                            <lucide-icon color="white" size="24" name="ellipsis"></lucide-icon>
                        </button>
                        <mat-menu #todayMenu="matMenu" class="chatTiming_dropdown" xPosition="before">
                            <div class="list p-2">
                                <ul class="p-0 m-0">
                                    <li><lucide-icon name="share" size="18"></lucide-icon> <span
                                            (click)="startShareChat(chat.uuid)">Share</span></li>
                                    <li><lucide-icon name="pencil" size="18"></lucide-icon> <span
                                            (click)="startEditChat(chat)">Rename</span></li>
                                    <li class="delete"><lucide-icon name="trash-2" size="18"></lucide-icon> <span
                                            (click)="deleteChat(chat.uuid)">Delete</span></li>
                                </ul>
                            </div>
                        </mat-menu>
                    </li>
                </ul>
            </div>

            <!-- Yesterday Chats -->
            <div *ngIf="yesterdayChats.length > 0" class="chats_timing pt-2">
                <h3>Yesterday</h3>
                <ul>
                    <li *ngFor="let chat of yesterdayChats" [class.active]="chat.isActive">
                        <span class="d-block w-100" *ngIf="editChatUuid !== chat.uuid"
                            (click)="getUserChatDetails(chat, false)">{{ chat.chatName }}</span>
                        <input *ngIf="editChatUuid === chat.uuid" [(ngModel)]="newChatName" (blur)="saveChatName(chat)"
                            (keydown.enter)="saveChatName(chat)" (keydown.esc)="cancelEdit()"
                            class="chat-edit-input w-100 py-2 px-2" />
                        <div class="overlay" (click)="getUserChatDetails(chat, false)"
                            *ngIf="editChatUuid !== chat.uuid"></div>
                        <button [matMenuTriggerFor]="YesterdayMenu" *ngIf="editChatUuid !== chat.uuid">
                            <lucide-icon color="white" size="24" name="ellipsis"></lucide-icon>
                        </button>
                        <mat-menu #YesterdayMenu="matMenu" class="chatTiming_dropdown" xPosition="before">
                            <div class="list p-2">
                                <ul class="p-0 m-0">
                                    <li><lucide-icon name="share" size="18"></lucide-icon> <span
                                            (click)="startShareChat(chat.uuid)">Share</span></li>
                                    <li><lucide-icon name="pencil" size="18"></lucide-icon> <span
                                            (click)="startEditChat(chat)">Rename</span></li>
                                    <li class="delete"><lucide-icon name="trash-2" size="18"></lucide-icon> <span
                                            (click)="deleteChat(chat.uuid)">Delete</span></li>
                                </ul>
                            </div>
                        </mat-menu>
                    </li>
                </ul>
            </div>
            <!-- Previous 7 days Chats -->
            <div *ngIf="previous7DaysChats.length > 0" class="chats_timing pt-2">
                <h3>Previous 7 days</h3>
                <ul>
                    <li *ngFor="let chat of previous7DaysChats" [class.active]="chat.isActive">
                        <span class="d-block w-100" *ngIf="editChatUuid !== chat.uuid"
                            (click)="getUserChatDetails(chat, false)">{{ chat.chatName }}</span>
                        <input *ngIf="editChatUuid === chat.uuid" [(ngModel)]="newChatName" (blur)="saveChatName(chat)"
                            (keydown.enter)="saveChatName(chat)" (keydown.esc)="cancelEdit()"
                            class="chat-edit-input w-100 py-2 px-2" />
                        <div class="overlay" (click)="getUserChatDetails(chat, false)"
                            *ngIf="editChatUuid !== chat.uuid"></div>
                        <button [matMenuTriggerFor]="SevenDayMenu" *ngIf="editChatUuid !== chat.uuid">
                            <lucide-icon color="white" size="24" name="ellipsis"></lucide-icon>
                        </button>
                        <mat-menu #SevenDayMenu="matMenu" class="chatTiming_dropdown" xPosition="before">
                            <div class="list p-2">
                                <ul class="p-0 m-0">
                                    <li><lucide-icon name="share" size="18"></lucide-icon> <span
                                            (click)="startShareChat(chat.uuid)">Share</span></li>
                                    <li><lucide-icon name="pencil" size="18"></lucide-icon> <span
                                            (click)="startEditChat(chat)">Rename</span></li>
                                    <li class="delete"><lucide-icon name="trash-2" size="18"></lucide-icon> <span
                                            (click)="deleteChat(chat.uuid)">Delete</span></li>
                                </ul>
                            </div>
                        </mat-menu>
                    </li>
                </ul>
            </div>
            <!-- Previous 30 days Chats -->
            <div *ngIf="previous30DaysChats.length > 0" class="chats_timing pt-2">
                <h3>Previous 30 days</h3>
                <ul>
                    <li *ngFor="let chat of previous30DaysChats" [class.active]="chat.isActive">
                        <span class="d-block w-100" *ngIf="editChatUuid !== chat.uuid"
                            (click)="getUserChatDetails(chat, false)">{{ chat.chatName }}</span>
                        <input *ngIf="editChatUuid === chat.uuid" [(ngModel)]="newChatName" (blur)="saveChatName(chat)"
                            (keydown.enter)="saveChatName(chat)" (keydown.esc)="cancelEdit()"
                            class="chat-edit-input w-100 py-2 px-2" />
                        <div class="overlay" (click)="getUserChatDetails(chat, false)"
                            *ngIf="editChatUuid !== chat.uuid"></div>
                        <button [matMenuTriggerFor]="ThirtyDayMenu" *ngIf="editChatUuid !== chat.uuid">
                            <lucide-icon color="white" size="24" name="ellipsis"></lucide-icon>
                        </button>
                        <mat-menu #ThirtyDayMenu="matMenu" class="chatTiming_dropdown" xPosition="before">
                            <div class="list p-2">
                                <ul class="p-0 m-0">
                                    <li><lucide-icon name="share" size="18"></lucide-icon> <span
                                            (click)="startShareChat(chat.uuid)">Share</span></li>
                                    <li><lucide-icon name="pencil" size="18"></lucide-icon> <span
                                            (click)="startEditChat(chat)">Rename</span></li>
                                    <li class="delete"><lucide-icon name="trash-2" size="18"></lucide-icon> <span
                                            (click)="deleteChat(chat.uuid)">Delete</span></li>
                                </ul>
                            </div>
                        </mat-menu>
                    </li>
                </ul>
            </div>
            <div *ngIf="sharedChatList.length > 0" class="chats_timing pt-2">
                <h3>Shared Insights</h3>
                <ul>
                    <li *ngFor="let chat of sharedChatList" [class.active]="chat.isActive"
                        [matTooltip]="'Shared By : ' + chat.senderName" matTooltipPosition="above">
                        <span class="d-block w-100" (click)="getUserChatDetails(chat, true)">{{chat.chatName}}</span>
                        <div class="overlay" (click)="getUserChatDetails(chat,true)"></div>
                        <button [matMenuTriggerFor]="sharedMenu">
                            <lucide-icon color="white" size="24" name="ellipsis"></lucide-icon>
                        </button>
                        <mat-menu #sharedMenu="matMenu" class="chatTiming_dropdown" xPosition="before">
                            <div class="list p-2">
                                <ul class="p-0 m-0">
                                    <li class="delete"><lucide-icon name="trash-2" size="18"></lucide-icon> <span
                                            (click)="deleteSharedChat(chat.uuid, chat.sharedWith)">Delete</span></li>
                                </ul>
                            </div>
                        </mat-menu>
                    </li>
                </ul>
            </div>
        </nav>
    </aside>
    <div class="regular_chat_card py-4" [ngClass]="previewVisible ? 'another-card' : null">
        <div class="preview_page" *ngIf="previewVisible">
            <div class="card position-relative">
                <i class="pi pi-times cross_btn" aria-hidden="true" (click)="closeCard()"></i>
                <div class="card-header" *ngIf="isPdf">
                    <nav class="d-flex align-items-center justify-content-center gap-10">
                        <!-- *ngIf="isLoaded && isPdf" -->
                        <button (click)="prevPage()" [disabled]="page === 1" class="previous btn btn-sm">
                            <lucide-icon size="15" name="move-left"></lucide-icon>
                        </button>
                        <p class="mb-0">{{ page }} / {{ totalPages }}</p>
                        <button (click)="nextPage()" [disabled]="page === totalPages" class="next btn btn-sm">
                            <lucide-icon size="15" name="move-right"></lucide-icon>
                        </button>
                        <button class="border-0 p-0 bg-transparent" (click)="zoomIn()">
                            <lucide-icon class="text-blue-lucide" name="zoom-in"></lucide-icon>
                        </button>
                        <button class="border-0 p-0 bg-transparent" (click)="zoomOut()">
                            <lucide-icon class="text-blue-lucide" name="zoom-out"></lucide-icon>
                        </button>
                    </nav>
                </div>
                <div class="card-body py-4">
                    <pdf-viewer *ngIf="isPdf" [src]="pdfContent" [render-text]="true" [original-size]="false"
                        (after-load-complete)="afterLoadComplete($event)" [show-all]="true"
                        [external-link-target]="'blank'" [(page)]="page" [zoom]="zoomLevel" [zoom-scale]="'page-width'"
                        (onError)="onPdfError($event)" [fit-to-page]="true" [autoresize]="true" [show-toolbar]="true"
                        (onPageChange)="onPageChanged($event)" class="content w-100 h-100"></pdf-viewer>
                    <!-- <iframe *ngIf="isPdf" [src]="pdfContent | safe" class="content w-100 h-100"></iframe> -->
                    <iframe *ngIf="isTxt" [src]="pdfContent | safe" class="content w-100 h-100"></iframe>
                </div>
            </div>
        </div>
        <div class="main-card" [ngClass]="previewVisible ? 'visible-part' : null">
            <div class="chat-header px-4 d-flex align-items-start justify-content-between">
                <div class="docs_tags" *ngIf="!isProcessed">
                    <div class="tags d-flex align-items-center gap-2" *ngFor="let item of documentDetail">
                        <span (click)="openDocument(item)">{{ item.documentName }}</span>
                        <button *ngIf="!isSharedChat" (click)="removeDocument(item)"
                            class="cross-button p-0 border-0 ml-2 bg-transparent">
                            <lucide-icon class="text-primary-lucide" size="18" name="badge-x"></lucide-icon>
                        </button>
                    </div>
                </div>
                <div class="d-flex docs_tags align-items-center gap-2 flex-wrap" *ngIf="isProcessed">
                    <p-skeleton width="12rem" height="2.3rem" borderRadius="16px" />
                    <p-skeleton width="10rem" height="2.3rem" borderRadius="16px" />
                    <p-skeleton width="18rem" height="2.3rem" borderRadius="16px" />
                    <p-skeleton width="32rem" height="2.3rem" borderRadius="16px" />
                    <p-skeleton width="12rem" height="2.3rem" borderRadius="16px" />
                    <p-skeleton width="10rem" height="2.3rem" borderRadius="16px" />
                    <p-skeleton width="18rem" height="2.3rem" borderRadius="16px" />
                    <p-skeleton width="32rem" height="2.3rem" borderRadius="16px" />
                </div>
                <div class="btn-group insight-btn-group">
                    <button class="border-0 p-0 bg-transparent" (click)="startAttachmentProcess()" *ngIf="!isSharedChat"
                        [disabled]="isProcessingStarted">
                        <lucide-icon class="text-blue-lucide mt-2" name="sparkles"></lucide-icon>
                    </button>
                </div>
                <!-- <div class="btn-group settings_dropdown" dropdown [insideClick]="true">
                    <i id="button-animated" dropdownToggle type="button" class="dropdown-toggle pi pi-cog"
                        aria-controls="dropdown-animated"></i>
                    <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                        aria-labelledby="button-animated">
                        <div class="content">
                            <div class="header mb-3 d-flex align-items-center justify-content-between">
                                <h4 class="m-0">Model Settings</h4>
                                <i class="pi pi-times cursor-pointer" aria-hidden="true"></i>
                            </div>
                            <div class="form-group">
                                <label>Document Batch Size</label>
                                <div class="form-inputs">
                                    <input type="number" />
                                    <button>+</button>
                                    <button>-</button>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Document Batch Size</label>
                                <div class="form-inputs">
                                    <input type="number" />
                                    <button>+</button>
                                    <button>-</button>
                                </div>
                            </div>
                            <div class="form-group">
                                <label
                                    class="d-flex mb-0 align-items-center justify-content-between"><span>Constraint</span>
                                    <span>{{slider.value}}</span></label>
                                <mat-slider>
                                    <input matSliderThumb [(ngModel)]="value" #slider>
                                </mat-slider>
                            </div>
                            <div class="form-group">
                                <label class="d-flex mb-0 align-items-center justify-content-between"><span>Text
                                        Chunks</span> <span>{{slider.value1}}</span></label>
                                <mat-slider>
                                    <input matSliderThumb [(ngModel)]="value1" #slider>
                                </mat-slider>
                            </div>
                            <div class="form-group mb-0">
                                <label class="d-flex mb-0 align-items-center justify-content-between"><span>Text
                                        Overlap</span> <span>{{slider.value2}}</span></label>
                                <mat-slider>
                                    <input matSliderThumb [(ngModel)]="value2" #slider>
                                </mat-slider>
                            </div>
                        </div>
                        <div class="content mt-3">
                            <h4>Search Settings</h4>
                            <div class="form-group">
                                <label class="d-flex mb-0 align-items-center justify-content-between"><span>Hybrid
                                        Alpha</span> <span>{{slider.value}}</span></label>
                                <mat-slider>
                                    <input matSliderThumb [(ngModel)]="value" #slider>
                                </mat-slider>
                            </div>
                            <div class="form-group">
                                <label class="d-flex mb-0 align-items-center justify-content-between"><span>Score
                                        Threshold</span> <span>{{slider.value1}}</span></label>
                                <mat-slider>
                                    <input matSliderThumb [(ngModel)]="value1" #slider>
                                </mat-slider>
                            </div>
                            <div class="form-group mb-0">
                                <label class="d-flex mb-0 align-items-center justify-content-between"><span>Lambda
                                        Multiplier</span> <span>{{slider.value2}}</span></label>
                                <mat-slider>
                                    <input matSliderThumb [(ngModel)]="value2" #slider>
                                </mat-slider>
                            </div>
                        </div>
                        <button class="btn mt-3 btn-primary btn-sm">Save Settings</button>
                    </ul>
                </div> -->
            </div>
            <app-progress-bar [isLoading]="isLoadingMenu"></app-progress-bar>
            <div class="chat-body mt-4">
                <div class="chats px-4" id="rigMainChatBox">
                    <!-- <div class="send">
                        <div class="user"></div>
                        <div class="messege"><span>HI ITS ME AGAIN</span></div>
                    </div>
                    <div class="send">
                        <div class="user"></div>
                        <div class="messege"><span>HI ITS ME AGAIN</span></div>
                    </div> -->
                    <!-- <div class="send_messege">
                        <div class="send">
                            <div class="messege"><span>Lorem Ipsum is simply dummy</span></div>
                            <p-avatar image="https://primefaces.org/cdn/primeng/images/demo/avatar/asiyajavayant.png"
                                styleClass="mr-2" size="large" shape="circle"></p-avatar>
                        </div>

                    </div>
                    <div class="send_messege reply_messege">
                        <div class="send reply">
                            <p-avatar image="https://primefaces.org/cdn/primeng/images/demo/avatar/asiyajavayant.png"
                                styleClass="mr-2" size="large" shape="circle"></p-avatar>
                            <div class="messege"><span>Lorem Ipsum is simply dummy text of the printing and typesetting
                                    industry. Lorem Ipsum has been the industry's standard dummy text ever since the
                                    1500s</span></div>
                        </div>
                    </div> -->
                    <ng-container *ngFor="let message of messages; let i = index">
                        <div class="send_messege" [ngClass]="{ reply_messege: message.role == 'assistant' }">
                            <div class="send" [ngClass]="{ reply: message.role == 'assistant' }">
                                <ng-container *ngIf="
                    message.role == 'assistant' && (!isReplyLoading || i !== 0)
                  ">
                                    <p-avatar image="../../../assets/images/bot.png" styleClass="mr-2" size="large"
                                        shape="circle">
                                    </p-avatar>
                                    <div class="messege position-relative">
                                        <markdown class="copymessege position-relative text-left d-block"
                                            [data]="message.content" [disableSanitizer]="true">
                                        </markdown>
                                        <div class="typingMessage text-left d-block" *ngIf="isresponseOngoing && i === 0">
                                            <div class="typing">
                                                <div class="dot"></div>
                                                <div class="dot"></div>
                                                <div class="dot"></div>
                                            </div>
                                        </div>
                                        <button class="btn-clipboard" matTooltip="Copy to ClipBoard"
                                            (click)="copyToClickboard(message.content)" matTooltipPosition="above">
                                            <lucide-icon size="16" name="clipboard"></lucide-icon>
                                        </button>
                                    </div>
                                    <lucide-icon class="info-btn" size="17" name="badge-info"
                                        *ngIf="message.source.length > 0" [matMenuTriggerFor]="menu"></lucide-icon>
                                    <mat-menu #menu="matMenu" class="info_dropdown" xPosition="before">
                                        <div class="list p-2">
                                            <ul class="p-0 m-0">
                                                <li *ngFor="let item of message.source">
                                                    {{ item.Title }} from {{ item.PageNo }}
                                                </li>
                                            </ul>
                                        </div>
                                    </mat-menu>
                                </ng-container>
                                <ng-container *ngIf="message.role == 'assistant' && isReplyLoading && i === 0">
                                    <p-avatar image="../../../assets/images/bot.png" styleClass="mr-2" size="large"
                                        shape="circle">
                                    </p-avatar>
                                    <div class="messege typingMessage text-left d-block">
                                        <div class="typing">
                                            <div class="dot"></div>
                                            <div class="dot"></div>
                                            <div class="dot"></div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="!(message.role == 'assistant')">
                                    <div class="messege text-left d-block">
                                        <span>{{ message.content }}</span>
                                    </div>
                                    <p-avatar [image]="null" styleClass="mr-2" size="large" shape="circle">{{
                                        message.role == "assistant"
                                        ? ""
                                        : (
                                        userFirstName.charAt(0) + userLastName.charAt(0)
                                        ).toUpperCase()
                                        }}
                                    </p-avatar>
                                </ng-container>
                                <!-- <p-avatar
                                    [image]="message.isBot ? 'https://primefaces.org/cdn/primeng/images/demo/avatar/asiyajavayant.png' : null"
                                    styleClass="mr-2" size="large" shape="circle">{{message.isBot ? '' :  (userFirstName.charAt(0) + userLastName.charAt(0)).toUpperCase() }}
                                </p-avatar>
                                <div class="messege">
                                    <span>{{ message.text }}</span>
                                </div> -->
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="suggestion_qustion" [class.customCollapse]="isDownCollapse" *ngIf="!isSharedChat">
                    <div class="question-wrap">
                        <button class="cross_btn" (click)="downCollapse()">
                            <span></span>
                        </button>
                        <div class="question_row">
                            <div class="qustions" *ngFor="let item of suggestedQuestions">
                                <p>{{ item }}</p>
                                <i class="pi pi-send" aria-hidden="true" (click)="sendSuggestedMessage(item)"></i>
                            </div>
                        </div>
                        <!-- <lucide-icon name="x" class="cross_btn" size="17"></lucide-icon> -->
                    </div>
                </div>
            </div>

            <div class="chat-footer px-4">
                <div class="input-group" *ngIf="!isSharedChat">
                    <input type="text" placeholder="Ask Me a Question..." [(ngModel)]="userInput"
                        (keyup.enter)="sendMessage()" />
                    <button>
                        <img src="../../../assets/icons/file.png" (click)="documentDialogue()" />
                    </button>
                    <button>
                        <img src="../../../assets/icons/link.png" (click)="linkDialogue()" />
                    </button>
                    <!-- <button><img src="../../../assets/icons/clip.png" class="clip" /></button> -->
                    <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" />

                    <!-- Styled button -->
                    <label class="custom-upload-button mb-0">
                        <img src="../../../assets/icons/clip.png" (click)="openFileInput()" class="clip"
                            alt="Upload File" />
                    </label>
                    <button [disabled]="documentDetail.length == 0 || userInput.trim() == ''">
                        <img src="../../../assets/icons/send.png" (click)="sendMessage()" />
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="chat_loader" *ngIf="isLoaderChat">
        <div class="loading-text">
            <span class="loading-text-words">L</span>
            <span class="loading-text-words">O</span>
            <span class="loading-text-words">A</span>
            <span class="loading-text-words">D</span>
            <span class="loading-text-words">I</span>
            <span class="loading-text-words">N</span>
            <span class="loading-text-words">G</span>
            <span class="loading-text-words">.</span>
            <span class="loading-text-words">.</span>
            <span class="loading-text-words">.</span>
        </div>
    </div> -->
</div>

<!-- dialogue -->
<p-dialog header="Header" class="dialogue_doc" [(visible)]="dialogue" [modal]="true" [style]="{ width: '600px' }"
    [draggable]="false" [resizable]="false">
    <ng-template pTemplate="body">
        <form class="mb-3">
            <ng-container *ngIf="isLinkClicked">
                <div class="d-flex gap-15 align-items-end">
                    <div class="form-group flex-1 mb-0">
                        <div class="left inline control-label mb-1">Url Link</div>
                        <input name="linktxt" class="form-control form-control-sm border-bottom" type="url" id="type"
                            [(ngModel)]="hyperText" />
                    </div>
                    <button class="btn btn-add btn-sm text-white btn-blue text-white" (click)="addHyperLink()">
                        <i class="pi pi-plus"></i>
                    </button>
                </div>
                <div class="tag_link">
                    <div class="tags" *ngFor="let item of hyperLinkList; let i = index">
                        <span>{{ item }}</span><i class="pi pi-times" (click)="removeHyperLink(i)"></i>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="isDocTextClicked">
                <div>
                    <div class="form-group flex-1 mb-3">
                        <div class="left inline control-label mb-1">File Name</div>
                        <input name="filename" class="form-control form-control-sm border-bottom" type="text" id="type1"
                            [(ngModel)]="docTextName" />
                    </div>
                    <div class="form-group flex-1 mb-0">
                        <div class="left inline control-label mb-1">Text</div>
                        <textarea name="filetext" class="form-control form-control-sm border-bottom" type="url"
                            id="type2" [(ngModel)]="docText"></textarea>
                    </div>
                </div>
            </ng-container>
            <div class="submit_btn text-right mt-4">
                <button class="btn btn-add btn-sm text-white btn-blue text-white" type="button"
                    (click)="createAndUploadFile()" *ngIf="!isLoading">
                    Submit
                </button>
                <p-progressSpinner *ngIf="isLoading"></p-progressSpinner>
            </div>
        </form>
    </ng-template>
</p-dialog>

<p-dialog header="Share Chat" class="dialogue_doc" [(visible)]="sharedDialog" [modal]="true" [style]="{width:'600px'}"
    [draggable]="false" [resizable]="false">
    <ng-template pTemplate="body">
        <form class="mb-3">
            <ng-container>
                <div class="d-flex gap-15 align-items-end">
                    <div class="form-group flex-1 mb-0">
                        <label class="control-label fw"></label>
                        <mat-chip-grid #chipList>
                            <mat-chip-row *ngFor="let user of userDD" [selectable]="selectable" [removable]="removable"
                                (removed)="removeUser(user)">
                                {{user.displayName}}
                                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                            </mat-chip-row>
                            <input class="form-control form-control-sm mat-autodd-input" #userDDInput
                                [formControl]="searchUserCntrl" [matAutocomplete]="userAutocomplete"
                                [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                                (matChipInputTokenEnd)="addUser($event)">
                        </mat-chip-grid>

                        <mat-autocomplete #userAutocomplete="matAutocomplete"
                            (optionSelected)="selectedUserEvent($event)">
                            <mat-option *ngFor="let user of userList" [value]="user.userId">
                                {{user.displayName}}
                            </mat-option>
                        </mat-autocomplete>

                    </div>
                    <button class="btn btn-add btn-sm text-white btn-blue text-white" (click)="shareChat()">
                        <i class="pi pi-plus"></i>
                    </button>
                </div>
            </ng-container>
        </form>
    </ng-template>
</p-dialog>
<!-- dialogue -->